import { render, staticRenderFns } from "./userBind.vue?vue&type=template&id=72ab1f13&scoped=true&"
import script from "./userBind.vue?vue&type=script&lang=js&"
export * from "./userBind.vue?vue&type=script&lang=js&"
import style0 from "./userBind.vue?vue&type=style&index=0&id=72ab1f13&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ab1f13",
  null
  
)

export default component.exports